import { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Prompt } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';
import moment from 'moment';

import { getBusinessGroupList } from '../../../modules/businessGroup';
import { getGames } from '../../../modules/system/game';
import { upsertTournament, getTournamentDates, getTournamentBanners } from '../../../modules/tournament_api';
import { tournamentDialogDisplay } from './tournament-field-mapper';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faChevronDown, faEye } from '@fortawesome/free-solid-svg-icons';
import MarkdownIt from 'markdown-it';
import markdownItModifyToken from 'markdown-it-modify-token';
import MdEditor from 'react-markdown-editor-lite';
import { modifyToken } from '../../../services/utils/modifyToken';
import 'react-markdown-editor-lite/lib/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import './tournament-editor.css';
import { toast } from 'react-toastify';

import DatePicker from 'react-datepicker';

import TournamentDialog from '../tournaments/tournament-dialog';
import Banner from '../../../ui_refresh/components/Banner';
import { loadImageFromUrl } from '../../../modules/communication';

const mdParser = new MarkdownIt({ typographer: true, modifyToken });
mdParser.use(markdownItModifyToken);
const MAX_CHARACTERS = 100;
const MILISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;
const EDIT_TOURNAMENT_TITLE = 'Edit Tournament';
const CREATE_TOURNAMENT_TITLE = 'Create New Tournament';

class TournamentEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: '',
      navigate: '',

      businessGroupValidMsg: '',
      gameValidMsg: '',
      titleValidMsg: '',
      startDateValidMsg: '',
      endDateValidMsg: '',

      renderPreviewDialog: false,
      otherTournamentsDates: [],
      allTournamentsDates: [],

      tournament: {
        tournamentName: '',
        startDate: Date.now(),
        endDate: Date.now(),
        tournamentDescription: '',
        businessGroupId: 0,
        businessGroupName: '',
        gameId: 0,
        gameName: '',
        selectedBusinessGroups: [],
      },

      validationError: null,
      tournamentId: 0,
      formSubmitting: false,
      dirtyForm: false,
    };

    this.handleChangedValues = this.handleChangedValues.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.submitTournamentData = this.submitTournamentData.bind(this);
  }

  async componentDidMount() {
    const { dispatch } = this.props;

    if (typeof this.props.match.params.tournamentId !== 'undefined') {
      const { tournament } = this.props;
      let bannerImage = null;
      if (tournament.bannerImage) {
        bannerImage = await loadImageFromUrl(`TOURNAMENT_BANNER/${tournament.bannerImage}`);
      }
      this.setState({
        ...this.state,
        tournament,
        title: EDIT_TOURNAMENT_TITLE,
        bannerImage,
      });
      this.getTournamentDates(tournament.businessGroupId);
    } else {
      this.setState({
        ...this.state,
        title: CREATE_TOURNAMENT_TITLE,
      });
    }
    dispatch(getBusinessGroupList([], 'group_name'));
    dispatch(getGames([], 'name'));
    dispatch(getTournamentBanners());
  }

  async handleChangedValues(event) {
    if (event.target && event.target.id) {
      if (event.target.id === 'TournamentBuisnessGroupId') {
        this.getTournamentDates(event.target.value);

        this.setState({
          ...this.state,
          tournament: {
            ...this.state.tournament,
            businessGroupId: event.target.value,
            businessGroupName: event.target.options[event.target.selectedIndex].text,
          },
          dirtyForm: true,
        });
      } else if (event.target.id === 'TournamentGameSelectedId') {
        this.setState({
          ...this.state,
          tournament: {
            ...this.state.tournament,
            gameId: event.target.value,
            gameName: event.target.options[event.target.selectedIndex].text,
          },
          dirtyForm: true,
        });
      } else if (event.target.id === 'TournamentNameId') {
        this.setState({
          ...this.state,
          tournament: {
            ...this.state.tournament,
            tournamentName: event.target.value,
          },
          dirtyForm: true,
        });
      } else if (event.target.id === 'BannerGroupId') {
        const bannerId = parseInt(event.target.value, 10);
        const bannerImage = await this.loadBannerImageFromId(bannerId);
        this.setState({
          ...this.state,
          bannerImage,
          tournament: {
            ...this.state.tournament,
            bannerId,
          },
          dirtyForm: true,
        });
      }
    } else {
      this.setState({
        ...this.state,
        tournament: {
          ...this.state.tournament,
          tournamentDescription: event.text,
        },
        tournamentHtml: event.html,
        dirtyForm: true,
      });
    }
  }

  async loadBannerImageFromId(bannerId) {
    if (typeof bannerId !== 'undefined' && bannerId !== 0) {
      const bannerImagePath = this.props.tournamentBanners.filter((banner) => banner.id === bannerId)[0].image_path;
      return await loadImageFromUrl(`TOURNAMENT_BANNER/${bannerImagePath}`);
    }
    return null;
  }

  setStartDate(newStartDate) {
    if (!newStartDate) {
      return;
    }

    this.setState({
      ...this.state,
      tournament: {
        ...this.state.tournament,
        startDate: newStartDate.getTime(),
      },
      dirtyForm: true,
    });
  }

  setEndDate(newEndDate) {
    if (!newEndDate) {
      return;
    }

    this.setState({
      ...this.state,
      tournament: {
        ...this.state.tournament,
        endDate: newEndDate.getTime(),
      },
      dirtyForm: true,
    });
  }

  async validateFields() {
    const { tournament } = this.state;
    const { editMode } = this.props;

    let businessGroupValidMsg = '',
      gameValidMsg = '',
      titleValidMsg = '';

    if (editMode) {
      if (parseInt(tournament.businessGroupId, 10) === 0 || tournament.businessGroupId === undefined) {
        businessGroupValidMsg = 'Select business group';
      }
    } else {
      if (tournament.selectedBusinessGroups.length == 0) {
        businessGroupValidMsg = 'Select at least one business group';
      }
    }

    if (parseInt(tournament.gameId, 10) === 0 || tournament.gameId === undefined) {
      gameValidMsg = 'Select game';
    }

    if (
      tournament.tournamentName.length <= 0 ||
      tournament.tournamentName === '' ||
      tournament.tournamentName === undefined ||
      tournament.tournamentName.trim().length === 0
    ) {
      titleValidMsg = 'Title can not have less than 0 characters';
    } else if (tournament.tournamentName.length > MAX_CHARACTERS) {
      titleValidMsg = `Title can not have more than ${MAX_CHARACTERS} characters`;
    }

    //////////// DATES VALIDATIONS ////////////

    let endDateValidMsg = '';
    const now = Date.now();

    let timestampStartDate = tournament.startDate;
    if (typeof timestampStartDate === 'object') {
      timestampStartDate = timestampStartDate.getTime();
    }

    let timestampEndDate = tournament.endDate;
    if (typeof timestampEndDate === 'object') {
      timestampEndDate = timestampEndDate.getTime();
    }

    if (timestampEndDate <= timestampStartDate) {
      endDateValidMsg = 'End date must be after start date';
    } else if (now >= timestampStartDate && now >= timestampEndDate) {
      endDateValidMsg = 'End date must be after current time';
    }

    if (!businessGroupValidMsg && !gameValidMsg && !titleValidMsg && !endDateValidMsg) {
      this.setState({
        ...this.state,
        businessGroupValidMsg: '',
        gameValidMsg: '',
        titleValidMsg: '',
        endDateValidMsg: '',
        validationError: '',
        tournament: {
          ...this.state.tournament,
          startDate: timestampStartDate,
          endDate: timestampEndDate,
        },
      });
      return true;
    } else {
      this.setState({
        ...this.state,
        businessGroupValidMsg,
        gameValidMsg,
        titleValidMsg,
        endDateValidMsg,
        validationError: '',
        tournament: {
          ...this.state.tournament,
          startDate: timestampStartDate,
          endDate: timestampEndDate,
        },
      });
      return false;
    }
  }

  async submitTournamentData(e) {
    e.preventDefault();
    if (await this.validateAndRecordTournament()) {
      this.setState({ ...this.state, dirtyForm: false, navigate: '/tournament' });
    }
  }

  async createPlusNew(e) {
    e.preventDefault();
    if (await this.validateAndRecordTournament()) {
      const { tournament } = this.state;
      tournament.startDate += MILISECONDS_IN_A_DAY;
      tournament.endDate += MILISECONDS_IN_A_DAY;
      tournament.gameId = 0;
      tournament.gameName = '';
      delete tournament['tournamentId'];
      this.setState({ ...this.state, tournament, title: CREATE_TOURNAMENT_TITLE });
    }
  }

  async validateAndRecordTournament() {
    const { tournament } = this.state;

    const isFieldsValid = await this.validateFields();

    let startDate = tournament.startDate;
    let endDate = tournament.endDate;

    //If start date is a time string, convert it to timestamp
    if (isNaN(startDate)) {
      startDate = new Date(startDate).getTime();
    }

    //If end date is a time string, convert it to timestamp
    if (isNaN(endDate)) {
      endDate = new Date(endDate).getTime();
    }

    const _tournament = { ...this.state.tournament, startDate: startDate, endDate: endDate };

    if (isFieldsValid) {
      try {
        await upsertTournament(_tournament);
        toast.success(
          `${_tournament.gameName} tournament on ${moment(_tournament.startDate).format('LLL')} at ${
            _tournament.businessGroupName
          } created successfully.`,
          { position: toast.POSITION.TOP_CENTER }
        );
        return true;
      } catch (e) {
        console.error(e);
        if (e.response && e.response.data) {
          const validationError = { ...e.response.data };
          delete validationError['new_auth'];
          this.setState({
            ...this.state,
            validationError,
            businessGroupValidMsg: '',
            gameValidMsg: '',
            titleValidMsg: '',
            endDateValidMsg: '',
          });
        }
      }
    }
    return false;
  }

  mapTheDates() {
    const { otherTournamentsDates } = this.state;

    const arr = [];

    for (let i = 0; i < otherTournamentsDates.length; i++) {
      const newStartDate = new Date(otherTournamentsDates[i]['start_time']);
      const newEndDate = new Date(otherTournamentsDates[i]['end_time']);
      const diffBetweenTheDates = Math.round((newEndDate.getTime() - newStartDate.getTime()) / (1000 * 3600 * 24));

      for (let j = 0; j < diffBetweenTheDates; j++) {
        const nextDay = new Date(newStartDate);
        nextDay.setDate(newStartDate.getDate() + j);
        arr.push(nextDay);
      }
    }

    this.setState({
      ...this.state,
      allTournamentsDates: arr,
    });
  }

  async getTournamentDates(businessGroupId = 0) {
    try {
      const response = await getTournamentDates(businessGroupId);
      this.setState({ ...this.state, otherTournamentsDates: response.data.dates });
      this.mapTheDates();
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const { businessGroups, games, tournamentBanners, formattedBusinessGroups, editMode } = this.props;
    const {
      navigate,
      tournament,
      businessGroupValidMsg,
      gameValidMsg,
      titleValidMsg,
      startDateValidMsg,
      endDateValidMsg,
      bannerValidMsg,
      renderPreviewDialog,
      validationError,
      allTournamentsDates,
      title,
      bannerImage,
    } = this.state;
    const _games = [{ id: 0, name: 'Select Game' }, ...games.filter((g) => !g.archived)];
    const _businessGroups = [{ id: 0, group_name: 'Select Business Group' }, ...businessGroups];
    const _tournamentBanners = [{ id: 0, name: 'Select Tournament Banner', image_path: '' }, ...tournamentBanners];
    if (navigate !== '') {
      return <Redirect to={navigate} />;
    }
    return (
      <div className="tw-mx-10 tw-my-5 tw-container tw-text-left">
        <Prompt
          when={this.state.dirtyForm}
          message="You have unsaved changes on this page. Are you sure you wish to leave?"
        />
        <h1 className="tw-font-extrabold tw-text-2xl">{title}</h1>
        <form className="tw-w-full tw-max-w-2xl tw-mt-5" onSubmit={(e) => this.submitTournamentData(e)}>
          <div className="tw-form-row">
            {editMode && (
              <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
                <label className="tw-form-label" htmlFor="grid-business-group">
                  Business group
                </label>
                <div className="tw-relative">
                  <select
                    id="TournamentBuisnessGroupId"
                    className={
                      businessGroupValidMsg
                        ? 'tw-form-input-invalid tw-form-input'
                        : 'tw-form-input-default tw-form-input'
                    }
                    onChange={this.handleChangedValues}
                    value={tournament.businessGroupId}
                  >
                    {_businessGroups.map((bg) => (
                      <option key={bg.id} value={bg.id}>
                        {bg.group_name}
                      </option>
                    ))}
                  </select>
                  <div className="tw-form-icon-input-overlay">
                    <FontAwesomeIcon icon={faChevronDown} className="tw-h-6 tw-w-6" />
                  </div>
                </div>
                {businessGroupValidMsg && (
                  <p className="tw-text-red-500 tw-text-s tw-italic">{businessGroupValidMsg}</p>
                )}
              </div>
            )}

            {!editMode && (
              <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
                <label className="tw-form-label" htmlFor="grid-business-group">
                  Buisness groups
                </label>
                <div className="tw-relative">
                  <MultiSelect
                    options={formattedBusinessGroups}
                    value={tournament.selectedBusinessGroups}
                    onChange={(newSelectedBusinessGroups) => {
                      this.setState({
                        tournament: { ...tournament, selectedBusinessGroups: newSelectedBusinessGroups },
                      });
                    }}
                    labelledBy="Select"
                  ></MultiSelect>
                </div>
                {businessGroupValidMsg && (
                  <p className="tw-text-red-500 tw-text-s tw-italic">{businessGroupValidMsg}</p>
                )}
              </div>
            )}
            <div className="tw-w-full md:tw-w-1/2 tw-px-3">
              <label className="tw-form-label" htmlFor="grid-game">
                Game
              </label>
              <div className="tw-relative">
                <select
                  id="TournamentGameSelectedId"
                  className={
                    gameValidMsg
                      ? 'tw-form-input-invalid tw-form-input tw-block'
                      : 'tw-form-input-default tw-form-input tw-block'
                  }
                  onChange={this.handleChangedValues}
                  value={tournament.gameId}
                >
                  {_games.map((g) => (
                    <option key={g.id} value={g.id}>
                      {g.name}
                    </option>
                  ))}
                </select>
                <div className="tw-form-icon-input-overlay">
                  <FontAwesomeIcon icon={faChevronDown} className="tw-h-6 tw-w-6" />
                </div>
              </div>
              {gameValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{gameValidMsg}</p>}
            </div>
          </div>
          <div className="tw-form-row">
            <div className="tw-w-full tw-px-3">
              <label className="tw-form-label" htmlFor="grid-game">
                Title
              </label>
              <input
                id="TournamentNameId"
                className={
                  titleValidMsg ? 'tw-form-input-invalid tw-form-input' : 'tw-form-input-default tw-form-input'
                }
                value={tournament.tournamentName}
                onChange={this.handleChangedValues}
              />
              {titleValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{titleValidMsg}</p>}
            </div>
          </div>
          <div className="tw-flex tw-flex-wrap tw--mx-3 tw-mb-3">
            <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
              <label className="tw-form-label" htmlFor="grid-start-time">
                Start Date
              </label>
              <DatePicker
                className={
                  startDateValidMsg
                    ? 'tw-form-input-invalid tw-form-input tw-block'
                    : 'tw-form-input-default tw-form-input tw-block'
                }
                showTimeSelect
                dateFormat="Pp"
                selected={new Date(tournament.startDate)}
                onChange={(date) => this.setStartDate(date)}
                excludeDates={allTournamentsDates}
              ></DatePicker>
              {startDateValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{startDateValidMsg}</p>}
              {validationError && <p className="tw-text-red-500 tw-text-s tw-italic">{validationError.description}</p>}
            </div>
            <div className="tw-w-full md:tw-w-1/2 tw-px-3 tw-mb-6 md:tw-mb-0">
              <label className="tw-form-label" htmlFor="grid-start-time">
                End Date
              </label>
              <DatePicker
                className={
                  endDateValidMsg
                    ? 'tw-form-input-invalid tw-form-input tw-block'
                    : 'tw-form-input-default tw-form-input tw-block'
                }
                showTimeSelect
                dateFormat="Pp"
                selected={new Date(tournament.endDate)}
                onChange={(date) => this.setEndDate(date)}
                excludeDates={allTournamentsDates}
              ></DatePicker>
              {endDateValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{endDateValidMsg}</p>}
            </div>
          </div>
          <div className="tw-form-row">
            <div className="tw-w-full tw-px-3">
              <label className="tw-form-label" htmlFor="grid-tournament-banner">
                Banner
              </label>
              <div className="tw-relative">
                <select
                  id="BannerGroupId"
                  className={
                    bannerValidMsg ? 'tw-form-input-invalid tw-form-input' : 'tw-form-input-default tw-form-input'
                  }
                  onChange={this.handleChangedValues}
                  value={tournament.bannerId}
                >
                  {_tournamentBanners.map((banner) => (
                    <option key={banner.id} value={banner.id}>
                      {banner.name}
                    </option>
                  ))}
                </select>
                <div className="tw-form-icon-input-overlay">
                  <FontAwesomeIcon icon={faChevronDown} className="tw-h-6 tw-w-6" />
                </div>
              </div>
              {bannerValidMsg && <p className="tw-text-red-500 tw-text-s tw-italic">{bannerValidMsg}</p>}
            </div>
          </div>
          <div className="tw-form-row">
            <div className="tw-w-full tw-px-3">
              <Banner bannerImage={bannerImage}>{tournament.tournamentName || 'Tournament title HERE!!!'}</Banner>
            </div>
          </div>
          <div className="tw-form-row">
            <div className="tw-w-full tw-px-3">
              <label className="tw-form-label" htmlFor="grid-start-time">
                Description (markup)
              </label>
              <MdEditor
                id="TournamentDescriptionId"
                style={{ height: '300px' }}
                renderHTML={(text) => mdParser.render(text)}
                value={tournament.tournamentDescription}
                onChange={({ text, html }) => this.handleChangedValues({ text, html })}
              />
            </div>
          </div>

          <div className="tw-form-row">
            <div className="tw-w-full tw-px-3">
              <button
                className="tw-btn tw-btn-secondary tw-float-right tw-mx-2"
                onClick={() => this.setState({ ...this.state, navigate: '/tournament' })}
              >
                Cancel
              </button>
              <button className="tw-btn tw-btn-primary tw-float-right">Submit</button>
              <button className="tw-btn tw-btn-success tw-float-right tw-mx-2" onClick={(e) => this.createPlusNew(e)}>
                {typeof tournament.tournamentId !== 'undefined' ? 'Update' : 'Create'} + New
              </button>
              <button
                className="tw-btn tw-btn-secondary tw-float-right"
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({ ...this.state, renderPreviewDialog: true });
                }}
                disabled={!tournament.gameId || !tournament.businessGroupId}
              >
                Preview&nbsp;
                <FontAwesomeIcon icon={faEye} className="tw-h-5 tw-w-5" />
              </button>
            </div>
          </div>
        </form>
        {renderPreviewDialog ? (
          <TournamentDialog
            hide_func={() => this.setState({ ...this.state, renderPreviewDialog: false })}
            tournament_data={tournamentDialogDisplay(tournament)}
            show={true}
          />
        ) : null}
      </div>
    );
  }
}

const emptyTournament = {
  tournamentName: '',
  startDate: Date.now(),
  endDate: Date.now(),
  tournamentDescription: '',
  businessGroupId: 0,
  businessGroupName: '',
  gameId: 0,
  gameName: '',
  bannerId: 0,
};

const formatBusinessGroups = (businessGroups) => {
  const formatted = [];
  for (const index in businessGroups) {
    const currentBusinessGroup = businessGroups[index];
    formatted.push({
      label: currentBusinessGroup.group_name,
      value: currentBusinessGroup.id,
    });
  }
  return formatted;
};

const withState = connect((state, props) => {
  const { tournament, game, business_group } = state;
  const { params } = props.match;
  let _state = {};

  let editMode = false;

  if (typeof params.tournamentId !== 'undefined') {
    let _tournament = tournament.tournaments.filter((t) => t.tournamentId === parseInt(params.tournamentId, 10));
    _tournament = _tournament.length > 0 ? _tournament[0] : emptyTournament;

    _state = {
      tournament: {
        ..._tournament,
      },
    };

    editMode = true;
  } else {
    _state = {
      tournament: emptyTournament,
    };
  }

  const formattedBusinessGroups = formatBusinessGroups(business_group.business_groups);
  _state = {
    ..._state,
    games: game.games,
    businessGroups: business_group.business_groups,
    formattedBusinessGroups: formattedBusinessGroups,
    tournamentBanners: tournament.tournamentBanners || [],
    editMode: editMode,
  };
  return _state;
});

export default withState(TournamentEditor);
